<template>
  <el-dialog title="收货地址" :visible.sync="dialogAddStockPriceProp">
    <el-form :model="addStockPrice">
      <el-form-item label="活动名称" :label-width="formLabelWidth">
        <el-input v-model="addStockPrice.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="活动区域" :label-width="formLabelWidth"></el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelAddStockPrice">取 消</el-button>
      <el-button type="primary" @click="confrimAddStockPrice">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "add-stock-price",
  data() {
    return {
      addStockPrice: {},
      formLabelWidth: "50px",
      dialogAddStockPriceProp: true
    };
  },
  props: {
    dialogAddStockPriceProp: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    cancelAddStockPrice() {
      this.dialogAddStockPriceProp = false;
    },
    confrimAddStockPrice() {}
  }
};
</script>

<style>
</style>